import { ThemeProvider } from "@emotion/react";
import About from "./components/about/about";
import Header from "./components/header/header";
import Skills from "./components/skills/skills";
import { theme } from "./theme";
import Experience from "./components/experience/experience";
import Projects from "./components/projects/projects";
import Certifications from "./components/certifications/certifications";
import SocialMedia from "./components/socialmedia/socialmedia";

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <Header />
            <About />
            <Skills />
            <Experience />
            <Projects />
            <Certifications />
            <SocialMedia />
        </ThemeProvider>
    );
}